module.exports = __webpack_public_path__ + "static/media/inverted-email.4d5ec0f0.svg";